import axios from 'axios'
import api from '@/api'
import i18next from 'i18next'

import {
  VUEX_API_ORDER_FETCH,
  VUEX_API_ORDER_CREATE,
  VUEX_API_ORDER_DUPLICATE,
  VUEX_API_ORDER_DELETE,
  VUEX_API_ORDER_BATCH_UPDATE,
  VUEX_API_ORDER_SUBMIT,
  VUEX_API_ORDER_ADD_COMMENT,
  VUEX_API_ORDER_ADDRESS_LOOKUP,
  VUEX_API_ORDER_ZIPCODE_LOOKUP,
  VUEX_API_ORDER_ADDRESS_VALIDATION,
  VUEX_API_ORDERS_REQUEST_FETCH,
  VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS,
  VUEX_API_ORDERS_REQUEST_FETCH_FAILED,
  VUEX_API_ORDER_APPROVAL_HISTORY,

  VUEX_API_ORDERS_WOF_STYLES_FETCH,
  VUEX_API_ORDERS_WOF_STYLE_COLORS_FETCH,

  VUEX_API_ORDERS_SET_CANCEL_TOKEN,
  VUEX_API_ORDERS_PRODUCTS_DELETE,
  VUEX_API_ORDERS_PRODUCTS_ADD,
  VUEX_API_ORDERS_DROP_PRODUCTS,
  VUEX_API_ORDER_EXCEL_EXPORT,

  VUEX_API_ORDER_STYLE_AUTOCOMPLETE_FETCH,
} from '@/store/constants/api'

import {
  VUEX_TOAST_SHOW
} from '@/store/constants/ui/toast'

import {
  VUEX_ORDERS_DETAIL_REFETCH
} from '@/store/constants/models/orders'

import { getTranslationMsgCodes } from '@/helpers/translationHelper'

// import ApiValidator from '@/classes/ApiValidator'

const state = {
  ordersRequest: null, // matthew: 7/22/2025 - this is used by every action - but we might want to split it up. right now, no component is watching this state

  //cancel requests
  ordersDetailListingCancelRequest: null,
  ordersListingCancelRequest: null,
  ordersCreateCancelRequest: null,
  ordersUpdateCancelRequest: null,
  ordersDuplicateCancelRequest: null,
  ordersCommentCancelRequest: null,
  ordersAddressLookupCancelRequest: null,
  ordersZipLookupCancelRequest: null,
  ordersAddressValidationLookupCancelRequest: null,
  ordersWofStyleLookupCancelRequest: null,
  ordersOrdersApprovalCancelRequest: null,
}

const getters = {}

const actions = {
  [VUEX_API_ORDER_FETCH]: async ({ commit, dispatch }, payload) => {
    if (!payload) payload = {}
    const { orderType, orderSubtype, data } = payload

    await commit(VUEX_API_ORDERS_REQUEST_FETCH)


    // cancel listing, in case it was active - because both store to agGridRowData
    if (state.ordersListingCancelRequest) state.ordersListingCancelRequest.cancel()
    await commit(VUEX_API_ORDERS_SET_CANCEL_TOKEN, 'ordersListingCancelRequest')

    // cancel any details listings that might be active
    if (state.ordersDetailListingCancelRequest) state.ordersDetailListingCancelRequest.cancel()
    await commit(VUEX_API_ORDERS_SET_CANCEL_TOKEN, 'ordersDetailListingCancelRequest')

    /* const newPayload = {
      orderNumber: id,
      _options
    } */

    return api.post(`orders/${orderType}/${orderSubtype}/query`, data, {
      cancelToken: state.ordersDetailListingCancelRequest.token
    }).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS)
      return response
    }).catch((err) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED)

      if (!axios.isCancel(err) && err.response.status < 500) {
        const errorMsg = getTranslationMsgCodes(err.response.data)

        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          persist: true,
          data: {
            type: 'error',
            message: errorMsg
          }
        })

        throw err
      }
    })
  },

  [VUEX_API_ORDERS_REQUEST_FETCH]: async ({ commit, dispatch }, payload) => {
    if (!payload) payload = {}
    let { orderType, orderSubtype, data } = payload
    await commit(VUEX_API_ORDERS_REQUEST_FETCH)

    if (state.ordersListingCancelRequest) state.ordersListingCancelRequest.cancel()
    await commit(VUEX_API_ORDERS_SET_CANCEL_TOKEN, 'ordersListingCancelRequest')

    return api.post(`orders/${orderType}/${orderSubtype}/query`, data, {
      cancelToken: state.ordersListingCancelRequest.token
    }).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS)

      return response
    }).catch((err) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED)

      if (!axios.isCancel(err) && err.response.status < 500) {
        const errorMsg = getTranslationMsgCodes(err.response.data)

        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          persist: true,
          data: {
            type: 'error',
            message: errorMsg
          }
        })

        throw err
      }
    })
  },

  [VUEX_API_ORDER_CREATE]: async ({ commit, dispatch }, payload) => {
    if (!payload) payload = {}
    const { orderType, orderSubtype, data } = payload

    await commit(VUEX_API_ORDERS_REQUEST_FETCH)

    if (state.ordersCreateCancelRequest) state.ordersCreateCancelRequest.cancel()
    await commit(VUEX_API_ORDERS_SET_CANCEL_TOKEN, 'ordersCreateCancelRequest')

    return await api.post(`orders/${orderType}/${orderSubtype}`, data, {
      cancelToken: state.ordersCreateCancelRequest.token
    }).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS)
      return response
    }).catch((err) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED)

      if (!axios.isCancel(err) && err.response.status < 500) {
        throw err.response
      }
    })
  },

  [VUEX_API_ORDER_DUPLICATE]: async ({ commit, dispatch }, payload) => {
    if (!payload) payload = {}
    const { orderType, orderSubtype, originalOrderId, data } = payload

    await commit(VUEX_API_ORDERS_REQUEST_FETCH)

    if (state.ordersDuplicateCancelRequest) state.ordersDuplicateCancelRequest.cancel()
    await commit(VUEX_API_ORDERS_SET_CANCEL_TOKEN, 'ordersDuplicateCancelRequest')

    return await api.post(`orders/${orderType}/${orderSubtype}/duplicate/${originalOrderId}`, data, {
      cancelToken: state.ordersDuplicateCancelRequest.token
    }).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS)
      return response
    }).catch((err) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED)

      if (!axios.isCancel(err) && err.response.status < 500) {
        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          persist: true,
          data: {
            type: 'error',
            message: `${err.response && err.response.data.message}`
          }
        })
      }
    })
  },

  [VUEX_API_ORDER_DELETE]: async ({ state, dispatch, commit }, payload = {}) => {
    const { orderType, orderSubtype, id } = payload

    commit(VUEX_API_ORDERS_REQUEST_FETCH, false)
    return api.delete(`orders/${orderType}/${orderSubtype}/${id}`,
      {}
    ).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS, true)
      return response
    }).catch((err, response) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED, false)

      if (!axios.isCancel(err) && err.response.status < 500) {
        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          persist: true,
          data: {
            type: 'error',
            message: `${err.response && err.response.data.message}`
          }
        })
      }
    })
  },

  [VUEX_API_ORDER_BATCH_UPDATE]: async ({ commit, dispatch }, payload) => {
    if (!payload) payload = {}

    const { orderType, orderSubtype, id, data } = payload

    await commit(VUEX_API_ORDERS_REQUEST_FETCH)

    if (state.ordersUpdateCancelRequest) state.ordersUpdateCancelRequest.cancel()
    await commit(VUEX_API_ORDERS_SET_CANCEL_TOKEN, 'ordersUpdateCancelRequest')
    return api.patch(`orders/${orderType}/${orderSubtype}/batch/${id}`, data, {
      cancelToken: state.ordersUpdateCancelRequest.token
    }).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS)

      return response
    }).catch((err) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED)

      if (!axios.isCancel(err) && err.response.status < 500) {

        if (!err.response.data?.errors.length) {
          const errorMsg = getTranslationMsgCodes(err.response.data)

          dispatch(VUEX_TOAST_SHOW, {
            component: '_core/Toast/Toast_Message.vue',
            persist: true,
            closeBtn: false,
            data: {
              refreshBtn: true,
              type: 'error',
              message: errorMsg
            }
          })
        }

        throw err.response
      }
    })
  },

  [VUEX_API_ORDER_ADD_COMMENT]: async ({ commit, dispatch }, payload) => {
    const { orderType, orderSubtype, id, data } = payload
    await commit(VUEX_API_ORDERS_REQUEST_FETCH)

    if (state.ordersCommentCancelRequest) state.ordersCommentCancelRequest.cancel()
    await commit(VUEX_API_ORDERS_SET_CANCEL_TOKEN, 'ordersCommentCancelRequest')
    return api.post(`orders/${orderType}/${orderSubtype}/comment/${id}`, data, {
      cancelToken: state.ordersCommentCancelRequest.token
    }).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS)
      return response
    }).catch((err) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED)

      if (!axios.isCancel(err) && err.response.status < 500) {
        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          data: {
            type: 'error',
            message: `${err.response && err.response.data.message}`
          }
        })
      }
    })
  },

  [VUEX_API_ORDER_ADDRESS_LOOKUP]: async ({ commit, dispatch }, payload) => {
    if (!payload) payload = {}
    const { orderType, orderSubtype, data } = payload
    await commit(VUEX_API_ORDERS_REQUEST_FETCH)

    if (state.ordersAddressLookupCancelRequest) state.ordersAddressLookupCancelRequest.cancel()
    await commit(VUEX_API_ORDERS_SET_CANCEL_TOKEN, 'ordersAddressLookupCancelRequest')

    return api.get(`orders/${orderType}/${orderSubtype}/accounts/address/${data}`, {
      cancelToken: state.ordersAddressLookupCancelRequest.token
    }).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS)
      return response
    }).catch((err) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED)

      if (!axios.isCancel(err) && err.response.status < 500) {
        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          persist: true,
          data: {
            type: 'error',
            message: `${err.response && err.response.data.message}`
          }
        })
      }
    })
  },

  [VUEX_API_ORDER_ZIPCODE_LOOKUP]: async ({ commit, dispatch }, payload) => {
    if (!payload) payload = {}

    await commit(VUEX_API_ORDERS_REQUEST_FETCH)

    if (state.ordersZipLookupCancelRequest) state.ordersZipLookupCancelRequest.cancel()
    await commit(VUEX_API_ORDERS_SET_CANCEL_TOKEN, 'ordersZipLookupCancelRequest')

    return api.get(`shippers/usps/citystate/${payload}`, {
      cancelToken: state.ordersZipLookupCancelRequest.token
    }).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS)
      return response
    }).catch((err) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED)

      if (!axios.isCancel(err) && err?.response?.status < 500) {
        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          data: {
            type: 'error',
            message: `${err.response && err.response.data.message}`
          }
        })
      }
    })
  },

  [VUEX_API_ORDER_ADDRESS_VALIDATION]: async ({ commit, dispatch }, payload) => {
    if (!payload) payload = {}

    await commit(VUEX_API_ORDERS_REQUEST_FETCH)

    if (state.ordersAddressValidationLookupCancelRequest) state.ordersAddressValidationLookupCancelRequest.cancel()
    await commit(VUEX_API_ORDERS_SET_CANCEL_TOKEN, 'ordersAddressValidationLookupCancelRequest')

    return api.post('shippers/ups/confirm/', payload, {
      cancelToken: state.ordersAddressValidationLookupCancelRequest.token
    }).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS)
      return response.data
    }).catch((err) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED)

      if (!axios.isCancel(err) && err.response.status < 500) {
        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          data: {
            type: 'error',
            message: `${err.response && err.response.data.message}`
          }
        })
      }
    })
  },

  [VUEX_API_ORDERS_PRODUCTS_ADD]: async ({ state, dispatch, commit }, payload = {}) => {
    const { orderType, orderSubtype, id, data } = payload

    const validatedPayload = data
    commit(VUEX_API_ORDERS_REQUEST_FETCH, false)

    return api.patch(`orders/${orderType}/${orderSubtype}/batch/${id}`,
      validatedPayload
    ).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS, true)
      return response
    }).catch((err, response) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED, false)

      if (!axios.isCancel(err) && err.response.status < 500) {
        const errorMsg = getTranslationMsgCodes(err.response.data)

        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          persist: true,
          closeBtn: false,
          data: {
            refreshBtn: true,
            type: 'error',
            message: errorMsg
          }
        })

        throw err.response
      }
    })
  },

  [VUEX_API_ORDERS_PRODUCTS_DELETE]: async ({ state, dispatch, commit }, payload = {}) => {
    const { orderType, orderSubtype, id, data } = payload

    const validatedPayload = data
    commit(VUEX_API_ORDERS_REQUEST_FETCH, false)

    return api.patch(`orders/${orderType}/${orderSubtype}/batch/${id}`,
      validatedPayload
    ).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS, true)

      return response
    }).catch((err, response) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED, false)

      if (!axios.isCancel(err) && err.response.status < 500) {
        const errorMsg = getTranslationMsgCodes(err.response.data)

        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          persist: true,
          closeBtn: false,
          data: {
            refreshBtn: true,
            type: 'error',
            message: errorMsg
          }
        })

        throw err.response
      }
    })
  },

  [VUEX_API_ORDERS_WOF_STYLES_FETCH]: async ({ rootState, state, dispatch, commit }, payload) => {
    if (state.ordersWofStyleLookupCancelRequest) state.ordersWofStyleLookupCancelRequest.cancel()
    await commit(VUEX_API_ORDERS_SET_CANCEL_TOKEN, 'ordersWofStyleLookupCancelRequest')

    const { region, origin, style, customer } = payload.data

    if (!region || !style) return new Error()
    if (!payload.params) payload.params = {}

    return api.get(`/orders/wof/style/autocomplete/${region}/${origin}/${customer}/${style}`,
      {
        params: payload.params,
        cancelToken: state.ordersWofStyleLookupCancelRequest.token
      }).then(response => {
      return response
    }).catch((err) => {
      if (!axios.isCancel(err) && err.response.status < 500) {

        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          data: {
            type: 'error',
            message: `${err.response && err.response.data.message}`
          }
        })
      }
    })
  },

  // Fetch Product(s) Styles Colors for autocomplete
  [VUEX_API_ORDERS_WOF_STYLE_COLORS_FETCH]: async ({ state, dispatch, commit }, payload) => {
    if (!payload.params) payload.params = {}

    return api.post(`/orders/wof/style`, payload.data).then(response => {
      // Throw error is style/colors data does not exist
      if (!response.data.colors.length) {
        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          data: {
            type: 'error',
            message: payload?.options?.emptyResponseMsg || `No style/color data found`
          }
        })
      }

      return response
    }).catch((err) => {

      if (!axios.isCancel(err) && err?.response?.status < 500) {
        const errorMsg = getTranslationMsgCodes(err.response.data)

        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          persist: true,
          data: {
            type: 'error',
            message: errorMsg
          }
        })
      }
    })
  },

  [VUEX_API_ORDERS_DROP_PRODUCTS]: async ({ state, dispatch, commit }, payload = {}) => {
    const { orderType, orderSubtype, id, data } = payload

    const validatedPayload = data
    commit(VUEX_API_ORDERS_REQUEST_FETCH, false)
    return api.patch(`orders/${orderType}/${orderSubtype}/batch/${id}`,
      validatedPayload
    ).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS, true)

      dispatch(VUEX_ORDERS_DETAIL_REFETCH)
      // dispatch(VUEX_GRID_REKEY)
      dispatch(VUEX_TOAST_SHOW, {
        component: '_core/Toast/Toast_Message.vue',
        timeout: 2000,
        data: {
          type: 'success',
          message: 'Success'
        }
      })
      return response
    }).catch((err, response) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED, false)

      if (!axios.isCancel(err) && err.response.status < 500) {
        const errorMsg = getTranslationMsgCodes(err.response.data)

        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          persist: true,
          data: {
            type: 'error',
            message: errorMsg
          }
        })
      }
    })
  },

  [VUEX_API_ORDER_APPROVAL_HISTORY]: async ({ commit, dispatch }, payload) => {
    if (!payload) payload = {}
    const { orderType, orderSubtype, requesterCode, productType } = payload
    await commit(VUEX_API_ORDERS_REQUEST_FETCH)

    if (state.ordersOrdersApprovalCancelRequest) state.ordersOrdersApprovalCancelRequest.cancel()
    await commit(VUEX_API_ORDERS_SET_CANCEL_TOKEN, 'ordersOrdersApprovalCancelRequest')

    return api.get(`orders/${orderType}/${orderSubtype}/year/${requesterCode}/${productType}`, {
      cancelToken: state.ordersOrdersApprovalCancelRequest.token
    }).then(response => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS)
      return response
    }).catch((err) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED)

      if (!axios.isCancel(err) && err.response.status < 500) {
        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          data: {
            type: 'error',
            message: `${err.response && err.response.data.message}`
          }
        })
      }
    })
  },

  [VUEX_API_ORDER_EXCEL_EXPORT]: async ({ state, dispatch, commit }, payload = {}) => {
    const { data, filename } = payload

    commit(VUEX_API_ORDERS_REQUEST_FETCH, false)
    return api.post(`order-documents/xlsx`,
      data,
      { responseType: 'arraybuffer', }
    ).then(response => {
      let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()

      commit(VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS, true)
      return response
    }).catch((err, response) => {
      commit(VUEX_API_ORDERS_REQUEST_FETCH_FAILED, false)


      if (!axios.isCancel(err) && err.response.status < 500) {
        if (err.response && err.response.data) {
          try {
            const decoder = new TextDecoder('utf-8');
            const responseText = decoder.decode(err.response.data);
            const json = JSON.parse(responseText);

            dispatch(VUEX_TOAST_SHOW, {
              component: '_core/Toast/Toast_Message.vue',
              persist: true,
              data: {
                type: 'error',
                title: i18next.t('msgCodes:ITS_FE_ERROR_DOCUMENT_EXPORT_ERROR.TITLE'),
                message: getTranslationMsgCodes({ messageCode: json.messageCode })
              }
            })
          } catch (e) {
            console.error('Could not parse error body as JSON:', e);
          }
        } else {
          console.error('Unhandled Axios error:', err);
        }
      }
    })
  },

  [VUEX_API_ORDER_STYLE_AUTOCOMPLETE_FETCH]: async ({ commit, dispatch }, payload) => {
    if (!payload) payload = {}
    const { region, origin, currency } = payload
    return api.get(`orders/wof/styles/${region}/${origin}/${currency}`, {}).then(response => {
      return response
    }).catch((err) => {
      return null

      /* if (!axios.isCancel(err) && err.response.status < 500) {
        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          data: {
            type: 'error',
            message: `VUEX_API_ORDER_STYLE_AUTOCOMPLETE_FETCH | Cannot load orders/wof/styles/${region}/${origin}/${currency} - ${err.response && err.response.data.message}`
          }
        })
      } */
    })
  },


}

const mutations = {
  [VUEX_API_ORDERS_REQUEST_FETCH]: state => {
    state.ordersRequest = ITS__API__REQUEST_TYPE__PENDING
  },
  [VUEX_API_ORDERS_REQUEST_FETCH_SUCCESS]: state => {
    state.ordersRequest = ITS__API__REQUEST_TYPE__SUCCESS
  },
  [VUEX_API_ORDERS_REQUEST_FETCH_FAILED]: state => {
    state.ordersRequest = ITS__API__REQUEST_TYPE__FAILED
  },

  // Set Cancelation token
  [VUEX_API_ORDERS_SET_CANCEL_TOKEN]: (state, data) => {
    state[data] = axios.CancelToken.source()
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
